import React from 'react'
import { connect } from 'react-redux'
import Component from '../common/Component'
import { benefitLabels, metadatumFieldsDiffSet } from './disabilityFields'
import publishingActions from '../../actions/BenefitsSetsExportPublishings'
import BenefitsSetExportShow from '../BenefitsSet/BenefitsSetExportShow'

export class DisabilityBenefitsSetExportShow extends Component {
  static defaultFields = [
    'id',
    'vericred_id',
    'approval_state',
    'publish_state',
    'name',
    'audience',
    'term',
    'plan_type',
    'plan_years',
    'stand_alone',
    'voluntary',
    'source',
    'issuer_identifier',
    'issuer_name'
  ]

  render() {
    return (
      <BenefitsSetExportShow
        productLine="Disability"
        benefitLabels={benefitLabels}
        metadatumFieldsDiffSet={metadatumFieldsDiffSet}
        defaultFields={DisabilityBenefitsSetExportShow.defaultFields}
        benefitsSetUrl="/disability_benefits"
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    exportPublish: state.benefitsSetsExportPublishings.create
  }
}

const mapDispatchToProps = {
  createExportPublish: publishingActions.create.main,
  resetCreateExportPublish: publishingActions.create.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(DisabilityBenefitsSetExportShow)
